import React from 'react';
import { Link } from 'react-router-dom';
import API from '../../../API';
import toast from 'react-hot-toast';
import {ru} from '../../../data/ru'
import {by} from '../../../data/by'
import './index.css'
import {TEST_CREATOR_CREATOR_URL} from "../../../../config";

export default function tests({data,SetData}) {
    let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;

    const api = new API() 

    const OnClickButtonDelete = async(id,name)=>{
        if(window.confirm("Удалить тест: "+ name)){
            try{
                await api.deleteTest(id);
                toast.success(`Тест ${name} удален`);
                const tests = await api.getTests()
                SetData(tests);
            }
            catch (e) {toast.error('Произошла ошибка')}
        }
      }
       
    return (
        <div>
            <div>
                <div className='test-editor-button-add-contener'>
                    <Link to={TEST_CREATOR_CREATOR_URL} className='test-editor-button-add'>{language.addTestButton}</Link>
                </div>
                <p className='tests-editor-description'>{language.followingTests}</p>
                {data && data.map((data,i)=>(
                    <div className='test-editor-question' key={'maindiv'+i}>
                        <h1>{data.name + " " + data.description}</h1>
                        <div className="test-editor-button-container">
                            {data.is_editable && <Link to={TEST_CREATOR_CREATOR_URL+data.id} className="test-creator-changebutton">&#x270e;</Link>}
                            {data.is_editable && <button onClick={e=>OnClickButtonDelete(data.id,data.name)} className='test-editor-button-delete'>x</button>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

